
import { priceFormat } from './currency';

 const getExtraPriceColor = (status)=>{
    let color; 
    if(status==='enable' || status==='checked') 
        color = 'accent.main'
    else color = 'text.muted'
    return color
   }

   const getOptionColor = (status)=>{
    let color; 
    if(status==='enable' || status==='checked') 
        color = 'text.primary'
    else   color = 'text.muted'

    return color
   }
   const getVariant= (status)=>{
    let variant; 
    if(status==='checked') 
        variant = 'h6'
    else if(status==='enable'){
      variant = 'body1'
    }else{
     variant = 'body2'
    }
    return variant
  }
  const getCounterOptions=(list)=>{
    //console.debug('getCounterOptions',list); 
    let counter=0; 
    list.forEach(o=>{
      if(o.counter)
        counter+=o.counter
    })
    return counter; 
  }

  const getOptionPrice = (currency,value,hideSimbol)=>{
    if(!value.price || value.price<=0.0)
      return ""
   const hide = hideSimbol? true: false;     
   return "+" + priceFormat(currency.style,value.price,hide); 
  }

  const getOptionText = (value)=>{
    if(!value.counter || value.counter<=0){
      return `- ${value.name}`; 
    }
    return `- ${value.counter}x ${value.name}`;  
  }

export {
    getOptionPrice,
    getOptionText,
    getExtraPriceColor,
    getOptionColor,
    getVariant, 
    getCounterOptions
}